import { exists } from 'neuro-utils';

export type TPulmonaryDocumentType = 'chestCircumference' | 'ventilationAid' | 'pulmonary';

/**
 * Check that the value exists and it's not null or an object with only a nonexistent value
 * @param  {any} value - Any value to be checked
 * @returns {boolean} True if value exists and isn't null, false if it doesn't exist or is null
 */
export const existsAndIsNotNull = (value: any): boolean => {
  if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
    const objectValue = value.value;
    if (Array.isArray(objectValue)) {
      return objectValue.length > 0 && exists(objectValue[0]) && objectValue[0] !== null;
    }
    return exists(objectValue) && objectValue !== null;
  }
  if (Array.isArray(value)) {
    return value.length > 0 && exists(value[0]) && value[0] !== null;
  }
  return exists(value) && value !== null;
};

/**
 * Merge all documents to one document that contains the latest values recorded and their respective dates
 * @param  {{[key:string]:any}[]} documents - All documents
 * @returns {{ [key: string]: any }} A document that has the latest values as date-value pairs combined from all documents
 */
export const mergeDocuments = (documents: { [key: string]: any }[]): { [key: string]: any } => {
  const merged = Object.assign({}, Array.isArray(documents) ? documents[0] : {});

  Object.keys(merged).map(
    key =>
      key.charAt(0) !== '_' && key !== 'date' && (merged[key] = { date: documents[0]?.['date'], value: merged[key] }),
  );
  Array.isArray(documents)
    ? documents.slice(1).map(document => {
        return Object.keys(document)
          .filter(key => {
            return key.charAt(0) !== '_';
          })
          .forEach(key => {
            !existsAndIsNotNull(merged[key])
              ? Object.assign(merged, { [key]: { date: document['date'], value: document[key] } })
              : undefined;
          });
      })
    : undefined;
  return merged;
};
